// ClobViewerDialog.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import { JsonView } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css"; // default light theme
// For dark theme, use: 'react-json-view-lite/dist/index-dark.css';

const ClobViewerDialog = ({ open, onClose, jsonData }) => {
  const handleCopyToClipboard = () => {
    if (jsonData) {
      // Pretty-print with 2-space indentation
      const formatted =
        typeof jsonData === "string"
          ? jsonData
          : JSON.stringify(jsonData, null, 2);
      navigator.clipboard.writeText(formatted);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      scroll="paper"
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span>Workspace JSON Data</span>
          {jsonData && (
            <Button
              onClick={handleCopyToClipboard}
              variant="outlined"
              size="small"
            >
              Copy to Clipboard
            </Button>
          )}
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {jsonData ? (
          <JsonView data={jsonData} />
        ) : (
          <div>No JSON data to display</div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClobViewerDialog;
